
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import BtnPlayLevel from "../btns/BtnPlayLevel";
import UIButton from "../../components/core/UIButton";
import FitTextToBounds from "../../components/core/FitTextToBounds";
/* START-USER-IMPORTS */
import { LevelNameValues } from "../../game/levels/level";
/* END-USER-IMPORTS */

export default class LevelItem extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 150, y ?? 175);

    // bg
    const bg = scene.add.image(0, 0, "level-select", "lvl-box.png");
    this.add(bg);

    // crackDecoration
    const crackDecoration = scene.add.image(0, 19, "level-select", "lvl-box-cracks.png");
    this.add(crackDecoration);

    // btnPlayLevel
    const btnPlayLevel = new BtnPlayLevel(scene, 0, 137);
    btnPlayLevel.scaleX = 1;
    btnPlayLevel.scaleY = 1;
    this.add(btnPlayLevel);

    // title
    const title = scene.add.text(0, -54, "", {});
    title.setOrigin(0.5, 0.5);
    title.tintTopLeft = 0;
    title.tintTopRight = 0;
    title.tintBottomLeft = 0;
    title.tintBottomRight = 0;
    title.text = "1";
    title.setStyle({ "align": "center", "fontFamily": "Acme-Regular", "fontSize": "80px" });
    this.add(title);

    // star1
    const star1 = scene.add.image(-85, -135, "level-select", "star-holder.png");
    star1.angle = -8;
    this.add(star1);

    // star2
    const star2 = scene.add.image(85, -135, "level-select", "star-holder.png");
    star2.angle = 8;
    this.add(star2);

    // star3
    const star3 = scene.add.image(0, -156, "level-select", "star-holder.png");
    this.add(star3);

    // scoreBox
    const scoreBox = scene.add.container(0, 44);
    scoreBox.angle = -5;
    this.add(scoreBox);

    // scoreBoxBG
    const scoreBoxBG = scene.add.sprite(0, 0, "level-select", "hi-score-box.png");
    scoreBox.add(scoreBoxBG);

    // score
    const score = scene.add.text(23, 0, "", {});
    score.setOrigin(0.5, 0.5);
    score.text = "150";
    score.setStyle({ "align": "center", "fontFamily": "Acme-Regular", "fontSize": "60px" });
    scoreBox.add(score);

    // highscoreIcon
    const highscoreIcon = scene.add.sprite(-55, 0, "level-select", "hi-score-trophy.png");
    scoreBox.add(highscoreIcon);

    // lockedBtn
    const lockedBtn = scene.add.container(0, 137);
    this.add(lockedBtn);

    // locked
    const locked = scene.add.image(0, 0, "common", "btn-level-select.png");
    lockedBtn.add(locked);

    // locked_icon
    const locked_icon = scene.add.image(0, -4, "common", "icon-locked-level.png");
    lockedBtn.add(locked_icon);

    // lists
    const stars = [star1, star3, star2];

    // btnPlayLevel (components)
    const btnPlayLevelUIButton = UIButton.getComponent(btnPlayLevel);
    btnPlayLevelUIButton.shouldPulse = false;

    // score (components)
    const scoreFitTextToBounds = new FitTextToBounds(score);
    scoreFitTextToBounds.maxWidth = 100;
    scoreFitTextToBounds.maxHeight = 50;
    scoreFitTextToBounds.constrainByWidth = true;

    this.crackDecoration = crackDecoration;
    this.btnPlayLevel = btnPlayLevel;
    this.title = title;
    this.star1 = star1;
    this.star2 = star2;
    this.star3 = star3;
    this.scoreBox = scoreBox;
    this.score = score;
    this.highscoreIcon = highscoreIcon;
    this.lockedBtn = lockedBtn;
    this.stars = stars;
    this.bg = bg;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  private crackDecoration: Phaser.GameObjects.Image;
  private btnPlayLevel: BtnPlayLevel;
  private title: Phaser.GameObjects.Text;
  private star1: Phaser.GameObjects.Image;
  private star2: Phaser.GameObjects.Image;
  private star3: Phaser.GameObjects.Image;
  private bg: Phaser.GameObjects.Image;
  private scoreBox: Phaser.GameObjects.Container;
  private score: Phaser.GameObjects.Text;
  private highscoreIcon: Phaser.GameObjects.Sprite;
  private lockedBtn: Phaser.GameObjects.Container;
  private stars: Phaser.GameObjects.Image[];
  public linkedLevel: LevelNameValues = "level1";

  /* START-USER-CODE */
  public starsUnlocked:number = 0;
  public levelNumber:number = 0;
  public highscore:number = 0;
  public unlocked:boolean = false;
  private downPosition:number = 0;

  public static events = {
    LevelSelected: 'levelSelected'
  } as const;

  public awake() {
    //this.init();
  }

  public init()
  {
    this.bindInput();

    this.title.text = this.levelNumber.toString();
    this.score.text = this.highscore.toString();
    for(let i = 0; i < this.stars.length; ++i)
    {
      if(i < this.starsUnlocked)
      {
        this.stars[i].setTexture(this.stars[i].texture.key,"star.png");
      }
    }
  }

  public bindInput() {
    if(this.unlocked)
    {
      this.bg.setInteractive();
      this.bg.on('pointerdown', this.onMouseDown, this);
      this.bg.on('pointerup', this.onPressed, this);


      this.btnPlayLevel.on(UIButton.events.clicked, this.onPressed, this);
      if(this.highscore == 0)
      {
        this.score.visible = false;
        this.highscoreIcon.visible = false;
        this.crackDecoration.visible = false;
      }
      this.lockedBtn.visible = false;
    }
    else {
      this.btnPlayLevel.visible = false;
      this.scoreBox.visible = false;
      this.crackDecoration.visible = false;
      this.lockedBtn.visible = true;
      for(let i = 0; i < this.stars.length; ++i)
      {
        this.stars[i].visible = false;
      }
    }
  }

  public pulseLevelButton(repeat:boolean)
  {
    if(repeat)
    {
      this.btnPlayLevel.setRepeatIdlePulse();
    }

    this.btnPlayLevel.UIButton.shouldPulse = true;
    this.scene.time.delayedCall(this.btnPlayLevel.UIButton.pulseDelay, this.btnPlayLevel.UIButton.pulseBtn, undefined, this.btnPlayLevel.UIButton);
  }

  protected onMouseDown()
  {
    this.downPosition = this.parentContainer.x;
  }

  protected onPressed() {
    console.log(this.parentContainer.x, this.downPosition);
    if(Math.abs(this.parentContainer.x - this.downPosition) < 100)
    {
      this.emit(LevelItem.events.LevelSelected, this);
    }
  }

  shutdown() {
    super.shutdown();
    this.btnPlayLevel.off(UIButton.events.clicked, this.onPressed, this);
    this.bg.off('pointerdown', this.onMouseDown, this);
    this.bg.off('pointerup', this.onPressed, this);
  }
  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
